import React, { useState, useEffect, useRef, useMemo } from "react";
import "react-simple-keyboard/build/css/index.css";
import { filter, map, isEmpty, find, forEach, create } from "lodash";
//import { bannerList } from "../../config/game-configs";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { ApiKey, ApiUrl, SessionKey, AlertTypes, PhoneNumberPrefix, WebUrl, TransactionType, BankingChannel, PanelType, LanguageOption } from "../../util/Constant";
import { setPlayableCategory, setRolloverTarget, startGame, setGameCategories } from "redux/GameAction";
import {
  setDisplayLogin,
  setDisplayRegister,
  setBusy,
  setIdle,
  showMessage,
  showResponseMessage,
  setBannerPopupImage,
  setBannerPopupModal,
  setAngpaoStatus,
  setShowAngpaoTnc
} from "../../redux/AppAction";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { performLogin, updateUserSpecialRollover, updateUserRolloverBalance } from "../../redux/AuthAction.js";
import {
  createFormBody,
  createMultiPartFormBody,
  numberWithCurrencyFormat,
  numberWithCurrencyFormat2,
  stringIsNullOrEmpty,
} from "./../../util/Util.js";
import ApiEngine from "./../../util/ApiEngine.js";
import { useHistory } from "react-router-dom";
import parse from "html-react-parser";
import PromoBanner from "components/promo-banner/PromoBanner";
import GameListRecommendMatch from "components/game-list/recommend-match";
import LiveChatModal from 'components/custom/LiveChatModal';
import CustomMiniGame from "components/custom/CustomMiniGame";
import DownloadApp from 'components/custom/DownloadApp';
import GameSectionV3 from "../../components/game-list/game-section-v3";
import BannerPopupModal from '../../components/custom/BannerPopupModal';
import LatestWinSlider from '../../components/custom/LatestWinSlider';
import SpinWheelButton from '../../components/spin-wheel/SpinWheelButton';
import NonSeamlessGameWalletModal from "../../components/custom/NonSeamlessGameWalletModal";
import AngpaoModal from "../../components/custom/AngpaoModal"; 

const Home = (props) => {
  const _history = useHistory();
  const { t, i18n } = useTranslation();
  const _dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.authState);
  var _userData = useSelector((state) => state.authState.userData);

  const [content, setContent] = useState("");
  const [games93Connect, setGames93Connect] = useState({});
  const [recommendedMatches, setRecommendedMatches] = useState([]);
  const { productCategory, rolloverTarget, playableCategory } = useSelector((state) => state.gameState);
  const [mainBannerData, setMainBannerData] = useState();
  const [promoBannerData, setPromoBannerData] = useState([]);
  const [availableMasterProducts, setAvailableMasterProducts] = useState([]);
  const [firstLoad, setFirstLoad] = useState(true);
  const [marqueUrl, setMarqueUrl] = useState("");

  const bannerSlick = {
    slidesToShow: 1,
    dots: true,
    arrows: false,
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    speed: 1000,
    autoplay: true,
  };


  //use effect region -------------------------------------------------------------------

  //init 
  useEffect(() => {
    getDesktopHomePageGeneralData();
  }, []);


  //trigger logged in function
  useEffect(() => {
    if (!firstLoad) {
        getDesktopHomePageAuthData();
    }

    if (isLoggedIn) {
      getAngpaoDrawRecord();
    }

    getAngpaoStatus();
  }, [isLoggedIn]);


  //trigger banner language marquee tag content follow the local storage 
  useEffect(() => {
    if (!firstLoad) {
      getDesktopHomePageLanguageData();
    }
  }, [i18n.language]);

  //use effect region end -------------------------------------------------------------------


  //api function region ---------------------------------------------------------------------

  async function startGame568SportsBook(matchId) {
    if (isLoggedIn) {
      _dispatch(setBusy());

      if (_userData.isSpecialRollover) {
        let productCategoryListArr = [...playableCategory];
        if (productCategoryListArr.includes("Sports")) {
          const result = await ApiEngine(
            ApiUrl._API_GET_MEMBER_PRODUCT_DETAILS_SPORTS_BOOK +
            "?matchId=" + matchId + "&device=d"
          );

          if (result[ApiKey._API_SUCCESS_KEY]) {
            const data = result[ApiKey._API_DATA_KEY];
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  url: data,
                })
              );
            }
            window.open(data);
          }
        }
        else {
          _dispatch(
            showMessage({
              type: AlertTypes._INFO,
              content: t("ROLLOVER_EXIST"),
              onConfirm: () => {
              },
            })
          );
        }
      }
      else {
        const result = await ApiEngine(
          ApiUrl._API_GET_MEMBER_PRODUCT_DETAILS_SPORTS_BOOK +
          "?matchId=" + matchId + "&device=d"
        );

        if (result[ApiKey._API_SUCCESS_KEY]) {
          const data = result[ApiKey._API_DATA_KEY];


          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                url: data,
              })
            );
          }
          window.open(data);
        }
      }

      _dispatch(setIdle());
    }
    else {
      // eslint-disable-next-line no-undef
      _dispatch(
        showMessage({
          type: AlertTypes._INFO,
          content: t("PLEASE_LOGIN_FIRST"),
          onConfirm: () => {
          },
        })
      );
    }
  }

  const getDesktopHomePageGeneralData = async () => {
    try {
      _dispatch(setBusy());
      let responseJson = await ApiEngine.get(ApiUrl._API_GET_DESKTOP_HOME_PAGE_GENERAL_DATA + "?isDesktop=true&languageCode=" +
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
          localStorage.getItem(SessionKey._LANGUAGE) : 'en'));

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        const originalData = responseJson[ApiKey._API_DATA_KEY];
        originalData["marqueeTagContents"].map((option) => {
          setContent(option["content"]);
          setMarqueUrl(option["url"]);
        });

        setMainBannerData(originalData["mainBanners"]);
        setPromoBannerData(originalData["promoBanners"]);
        if (originalData["popupBanners"] != null) {
          _dispatch(setBannerPopupImage(originalData["popupBanners"]));
          _dispatch(setBannerPopupModal(true));
        } else {
          _dispatch(setBannerPopupImage(""));
          _dispatch(setBannerPopupModal(false));
        }

        let matches = originalData['matches'];
        matches = matches.sort(function (a, b) {
          var dateA = new Date(a.kickOffTimeGMT);
          var dateB = new Date(b.kickOffTimeGMT);
          return dateA - dateB;
        });
        setRecommendedMatches(matches);
        setAvailableMasterProducts(originalData["availableMasterProducts"]);
        _dispatch(setGameCategories(originalData["productCategories"]));
        setFirstLoad(false);
      } else {
        setRecommendedMatches([]);
      }
      _dispatch(setIdle());
    } catch {
      _dispatch(setIdle());
    }
  }

  const getDesktopHomePageLanguageData = async () => {
    try {
      _dispatch(setBusy());
      let responseJson = await ApiEngine.get(ApiUrl._API_GET_DESKTOP_HOME_PAGE_LANGUAGE_DATA + "?isDesktop=true&languageCode=" +
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
          localStorage.getItem(SessionKey._LANGUAGE) : 'en'));

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        const originalData = responseJson[ApiKey._API_DATA_KEY];
        originalData["marqueeTagContents"].map((option) => {
          setContent(option["content"]);
        });

        setMainBannerData(originalData["mainBanners"]);
        setPromoBannerData(originalData["promoBanners"]);
        if (originalData["popupBanners"] != null) {
          _dispatch(setBannerPopupImage(originalData["popupBanners"]));
          _dispatch(setBannerPopupModal(true));
        } else {
          _dispatch(setBannerPopupImage(""));
          _dispatch(setBannerPopupModal(false));
        }
        _dispatch(setGameCategories(originalData["productCategories"]));
      }
      _dispatch(setIdle());
    } catch {
      _dispatch(setIdle());
    }
  }

  const getDesktopHomePageAuthData = async () => {
    try {
      _dispatch(setBusy());
      let responseJson = await ApiEngine.get(ApiUrl._API_GET_DESKTOP_HOME_PAGE_AUTH_DATA + "?isDesktop=true&languageCode=" +
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
          localStorage.getItem(SessionKey._LANGUAGE) : 'en'));

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        const originalData = responseJson[ApiKey._API_DATA_KEY];
        setMainBannerData(originalData["mainBanners"]);
        setPromoBannerData(originalData["promoBanners"]);
        if (originalData["popupBanners"] != null) {
          _dispatch(setBannerPopupImage(originalData["popupBanners"]));
          _dispatch(setBannerPopupModal(true));
        } else {
          _dispatch(setBannerPopupImage(""));
          _dispatch(setBannerPopupModal(false));
        }
        setAvailableMasterProducts(originalData["availableMasterProducts"]);
        _dispatch(setGameCategories(originalData["productCategories"]));
      }
      _dispatch(setIdle());
    } catch {

      _dispatch(setIdle());
    }
  }

  //api function region end ---------------------------------------------------------------------

  const handleBannerOnClick = async (bannerUrl) => {
    if (stringIsNullOrEmpty(bannerUrl) || bannerUrl === "#") {
      //do nothing
    }
    else {
      if (bannerUrl.startsWith("Game/StartGame?gameId=")) {
        if (isLoggedIn) {
          let game = bannerUrl.match("gameId=(.*)&isApp=");
          let gameId = game[1];
          var newResponseJson = await ApiEngine.get(
            ApiUrl._API_GET_MASTER_PRODUCT_GROUP_GAME_BY_GAME_ID + "?id=" + gameId
          );

          if (newResponseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = newResponseJson[ApiKey._API_DATA_KEY][ApiKey._API_DATA_KEY].filter(x => x.id == gameId)
            //startGame(data[0]);
            _dispatch(startGame(data[0]));
          }
        }
        else {
          // eslint-disable-next-line no-undef
          _dispatch(
            showMessage({
              type: AlertTypes._INFO,
              content: t("PLEASE_LOGIN_FIRST"),
              onConfirm: () => {
              },
            })
          );
        }
      } else {
        _history.push(bannerUrl);
        //const urlSplit = bannerUrl.split("/");
        //const productName = urlSplit[urlSplit.length - 1]
        //_history.push({
        //  pathname: WebUrl._URL_GAME_LIST.replace(":provider", productName),
        //});
      }
    }
  }

    const handleMarqueClick = () => {
        window.location.href = marqueUrl;
    };


  const getAngpaoStatus = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_ANGPAO_STATUS);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      _dispatch(setAngpaoStatus(responseJson[ApiKey._API_DATA_KEY]));
    }
  }

  const getAngpaoDrawRecord = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_ANGPAO_DRAW_RECORD + "?all=true");
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      if (stringIsNullOrEmpty(data)) {
        _dispatch(setShowAngpaoTnc(data.length > 0 ? false : true));
      }
    }
  }


  return (
    <>
      <div id="home-page">
        <div className="">
          <Slider {...bannerSlick} className="banner-slick">
            {mainBannerData &&
              mainBannerData.length > 0 &&
              map(mainBannerData, (item, index) => {
                return (
                  <div key={index} className="banner-items cursor-global">
                    <img src={item.image} alt="banner" className="banner-items-image" onClick={() => handleBannerOnClick(item.url)} />
                  </div>
                );
              })}
          </Slider>
        </div>
        <div className="home-announcement mt-4">
          <div>
            <img src="/img/version3/announce.png" alt="shout" />
          </div>
          <marquee direction="left">
                      <div onClick={() => {
                          handleMarqueClick();
                      }}>
                          <span>{parse(content)}</span>
                      </div>

          </marquee>
        </div>

        <GameSectionV3 data={availableMasterProducts} />

        <section>
          <PromoBanner promoBannerList={promoBannerData} />
        </section>

        {_userData.isSpecialRollover && productCategory && rolloverTarget !== 0 && _userData.rolloverBalance !== 0 ?
          <section>
            <div className="title-themed mt-5">
              <h4>{t("REMAINING_ROLLOVER")}</h4>
            </div>
            <div className="special-rollover-container mt-5">
              <div className="text-n-icon">
                <div className="icon-container">
                  {productCategory.map((item, index) => {
                    return (
                      <div className={`inner-container ${[...playableCategory].includes(item.originalTitle) ? "playable" : ""}`}>
                        <img
                          src={'/img/assets/game-category/svg/' + item.originalTitle + '.svg'}
                          className="img-responsive"
                          alt={item.label + " image"}
                          width="30"
                          height="30"
                        />
                        <span style={{ color: "#FFD928", fontSize: "13px", fontWeight: "700", letterSpacing: "1px" }}>{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="progress-bar-container">
                <div className="progress-bar-outline">
                  <span style={{ position: "absolute", textShadow: "2px 2px 5px black" }}>{numberWithCurrencyFormat((Math.abs(rolloverTarget - _userData.rolloverBalance) / (_userData.rolloverBalance + (rolloverTarget - _userData.rolloverBalance))) * 100, 2, true)}%</span>
                  <div className="progress-bar-fill"
                    style={{
                      width: `${(Math.abs(rolloverTarget - _userData.rolloverBalance) / (_userData.rolloverBalance + (rolloverTarget - _userData.rolloverBalance))) * 100}%`
                    }}
                  >
                  </div>
                </div>
              </div>
              <div className="rollover-text">
                {t("AMOUNT")}: RM {numberWithCurrencyFormat(Math.abs(rolloverTarget - _userData.rolloverBalance), 2, true) + " / " + numberWithCurrencyFormat((_userData.rolloverBalance + (rolloverTarget - _userData.rolloverBalance)), 2, true)} <span style={{ color: "#FFD928" }}></span>
              </div>
            </div>
            <hr className="hr-left" />
          </section>
          :
          <></>
        }
        <hr className="hr-right" />
        <div className="">
          <LatestWinSlider />
        </div>

        {recommendedMatches && recommendedMatches.length > 0 && <>
          <div className="home-title-with-arrows mt-5">
            <div className="title-themed">
              <h4>{t("UPCOMING_LIVE_MATCH")}</h4>
              <p>{t("ENJOY_UPCOMING_MATCH")}</p>
            </div>
          </div>
          <GameListRecommendMatch recommendedMatches={recommendedMatches} startGame568SportsBook={startGame568SportsBook} />
          <hr className="hr-right" />
        </>}

        <div className="home-title-with-arrows mt-5">
          <div className="title-themed">
            <h4>{t("APP_DOWNLOAD")}</h4>
            <p>{t("LETS_PLAY_TOGETHER")}</p>
          </div>
        </div>
        <DownloadApp />
      </div>

      <CustomMiniGame parentGames93Connect={games93Connect} />
      <BannerPopupModal />
      <SpinWheelButton />
      <NonSeamlessGameWalletModal />
      <AngpaoModal />
    </>
  );
};
export default Home;
